import { IMarketArea } from "features/MarketAreas/types";
import { apiClient } from "lib/apiClient";

export interface IEditMarketArea {
  name?: IMarketArea["name"];
  description?: IMarketArea["description"];
}

export const editMarketAreaById = async (
  id: string,
  request: IEditMarketArea
): Promise<IMarketArea> => {
  const response = await apiClient.patch<IMarketArea>(
    `/market-areas/${id}`,
    request
  );

  return response.data;
};
